import { render, staticRenderFns } from "./ProductDetails.vue?vue&type=template&id=537082ac"
import script from "./ProductDetails.vue?vue&type=script&lang=ts"
export * from "./ProductDetails.vue?vue&type=script&lang=ts"
import style0 from "./ProductDetails.vue?vue&type=style&index=0&id=537082ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports